// extracted by mini-css-extract-plugin
export var releaseWrapper = "ReleaseAccordion-module--releaseWrapper--e19b5";